import React from "react"
import SbEditable from "storyblok-react"
import { blokType } from "../../types"

import { CardResearchCmp, CardResearchProps } from "./CardResearch"
import { CardResearchSmallCmp, CardResearchSmallProps } from "./CardResearchSmall"
import { CardIconCmp, CardIconProps } from "./CardIcon"
import { CardEventCmp, CardEventProps } from "./CardEvent"

interface CardResearchWrapperBlokProps {
  blok: CardResearchProps & blokType
}

interface CardResearchSmallWrapperBlokProps {
  blok: CardResearchSmallProps & blokType
}

interface CardIconWrapperBlokProps {
  blok: CardIconProps & blokType
}

interface CardEventWrapperBlokProps {
  blok: CardEventProps & blokType
}

export const S23CCardResearch: React.FC<CardResearchWrapperBlokProps> = ({
  blok,
}) => (
  <SbEditable content={blok}>
    <CardResearchCmp
      category={blok.category}
      title={blok.title}
      author={blok.author}
      source={blok.source}
      year={blok.year}
      cta_button={blok.cta_button}
      background_color={blok.background_color}
      font_color={blok.font_color}
    />
  </SbEditable>
)

export const S23CCardResearchSmall: React.FC<CardResearchSmallWrapperBlokProps> = ({
  blok,
}) => (
  <SbEditable content={blok}>
    <CardResearchSmallCmp
      category={blok.category}
      title={blok.title}
      author={blok.author}
      cta_button={blok.cta_button}
      font_color={blok.font_color}
    />
  </SbEditable>
)

export const S23CCardIcon: React.FC<CardIconWrapperBlokProps> = ({ blok }) => (
  <SbEditable content={blok}>
    <CardIconCmp
      icon={blok.icon}
      title={blok.title}
      description={blok.description}
      cta_button={blok.cta_button}
    />
  </SbEditable>
)

export const S23CCardEvent: React.FC<CardEventWrapperBlokProps> = ({ blok }) => (
  <SbEditable content={blok}>
    <CardEventCmp
      date={blok.date}
      title={blok.title}
      description={blok.description}
      cta_button={blok.cta_button}
    />
  </SbEditable>
)
